import { ActivityIndicator, Linking, StyleSheet, Text, View } from "react-native";
import { FIREBASE_EVENT_NAMES, FIREBASE_EVENT_PARAMS, PAGES_ROUTES, PAGES_TITLE } from "utils/Constants";
import React, { useCallback, useEffect, useState } from "react";
import { fp, hp, spH, spV, wp } from "utils/normalizeV2";

import { Colors } from "colors";
import ListView from "components/ListView";
import OrderHistoryCard from "components/checkout/OrderHistoryCard";
import ParentScrollView from "components/ParentScrollView";
import SideProfileComp from "components/profile/SideProfileComp";
import VText from "components/VText";
import { analytics } from "utils/firebaseConfig";
import { getOrderHistory } from "appRedux/reducers/orderSlice";
import { logEvent } from "firebase/analytics";
import { router, useLocalSearchParams } from "expo-router";
import { useDispatch } from "react-redux";
import { trackV2 } from "utils/Segment";
import { ANALYTICS_EVENT_NAMES } from "utils/analytics";
import EmptyScreen from "components/emptyScreen";
import { Svg as Svgs } from "assets/svg";

const OrderHistory = ({}) => {
    const [isLoading, setLoader] = useState(false);
    const [orderHistoryList, setOrderHistoryList] = useState([]);
    const local = useLocalSearchParams();
    const gender = local?.gender || "female";

    const dispatch = useDispatch();

    useEffect(() => {
        const eventData = {
            total_orders: orderHistoryList?.length,
        };
        trackV2(ANALYTICS_EVENT_NAMES.ORDER_HISTORY_PAGE_VIEWED, eventData);
    }, [orderHistoryList]);

    useEffect(() => {
        setLoader(true);
        dispatch(getOrderHistory())
            .then((res) => {
                setLoader(false);
                if ([200].includes(res?.payload?.status)) {
                    setOrderHistoryList(res?.payload?.data);
                }
            })
            .catch((err) => {
                setLoader(false);
                alert("Error");
                console.log("err", err);
            });
    }, [dispatch]);

    const renderItem = ({ item }) => {
        const productDetails = item;
        const { totalAmount } = item;
        return (
            <OrderHistoryCard
                currentSize={productDetails?.size}
                productDetails={productDetails}
                totalAmount={totalAmount}
                showOrderBy={true}
                preorder={{
                    showPreorder: productDetails?.isPreorder,
                }}
                onPressReturnPolicy={() => {
                    if (productDetails?.returnObject?.url && productDetails?.returnObject?.url != "") {
                        Linking.openURL(productDetails?.returnObject?.url);
                    } else {
                        alert("Error");
                    }
                }}
                onPressCard={onPressCard}
            />
        );
    };

    const onPressCard = (productDetails) => {
        router.push(
            `/order-details?id=${productDetails?.id}&productId=${productDetails?.productId}&size=${productDetails?.size}&gender=${gender}`
        );
    };

    const renderContent = useCallback(() => {
        if (isLoading) {
            return (
                <View style={styles.loadingContainer}>
                    <ActivityIndicator size="large" color={Colors.black} />
                </View>
            );
        }
        if (orderHistoryList.length === 0) {
            return (
                <EmptyScreen
                    icon={Svgs.orderHistory}
                    description="You can view and track all of your orders, here."

                />
            );
        }
        return (
            <ListView
                showsVerticalScrollIndicator={false}
                data={Array.isArray(orderHistoryList) ? orderHistoryList : []}
                contentContainerStyle={{ paddingBottom: 100 }}
                renderItem={renderItem}
                scrollEnabled={false}
                keyExtractor={(item) => Math.random().toString()}
            />
        );
    }, [orderHistoryList, isLoading]);

    return (
        <ParentScrollView>
            <View style={styles.container}>
                <VText style={styles.header}>Order History</VText>
                <View style={styles.content}>
                    <SideProfileComp gender={gender} selected="Order History" />
                    <View style={styles.orderHistorySection}>{renderContent()}</View>
                </View>
            </View>
        </ParentScrollView>
    );
};
export default OrderHistory;

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: Colors.white,
        paddingTop: spV(32),
    },
    header: {
        textAlign: "center",
        fontSize: fp(28),
        fontFamily: "LibreBodoni",
        fontWeight: "350",
        marginBottom: spV(28),
    },
    content: {
        flex: 1,
        flexDirection: "row",
    },
    orderHistorySection: {
        width: wp(652),
        marginHorizontal: spH(80),
    },
    loadingContainer: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
    },
    emptyText: {
        fontFamily: "JosefinSans",
        fontSize: 20,
        fontWeight: "550",
        textAlign: "center",
        marginTop: spV(15),
    },
    emptyContainer: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
    },
});
